import axios from 'axios';

export default {
  namespaced: true,
  state: {
    contactsBulkActions: [],
    contactsBulkActionsTotal: 0,
    contacts: [],
    contactsTotal: 0,
    selectedBulkAction: {},
    isLoadingSelectedBulkAction: false,
    contactsBulkActionsInProgress: false,
    contactsBulkActionsError: false,
    contactsBulkActionsErrorMessage: '',
  },
  getters: {
    hasBulkAcionsLeftToFetch(state) {
      return state.contactsBulkActions.length < state.contactsBulkActionsTotal;
    },
    isDeleteContactsBulkAction(state) {
      if (!state.selectedBulkAction || !state.selectedBulkAction.action) return;

      const { type, resource } = state.selectedBulkAction.action;

      return type === 'delete' && resource === 'contacts';
    },
    isStopCampaignBulkAction(state) {
      if (!state.selectedBulkAction || !state.selectedBulkAction.action) return;

      const { action: { type, resource } } = state.selectedBulkAction;

      return type === 'stop' && resource === 'campaign';
    },
  },
  mutations: {
    setBulkActionsInProgress(state, value) {
      state.contactsBulkActionsInProgress = value;
    },
    setBulkActionsSuccess(state, contacts) {
      state.contactsBulkActions = contacts.data || contacts;
      state.contactsBulkActionsTotal = contacts.total;
    },
    setBulkActionsError(state, error) {
      state.contactsBulkActionsError = true;
      state.contactsBulkActionsErrorMessage = error.message;
    },
    appendBulkActions(state, contacts) {
      const data = contacts.data || contacts;
      state.contactsBulkActions = [...state.contactsBulkActions, ...data];
      state.contactsBulkActionsTotal = contacts.total;
    },
    clearBulkActions(state) {
      state.contactsBulkActions = [];
      state.contactsBulkActionsTotal = 0;
    },
    setContacts(state, data) {
      state.contacts = data;
    },
    setContactsTotal(state, total) {
      state.contactsTotal = total;
    },
    clearContactsData(state) {
      state.contacts = [];
      state.contactsTotal = 0;
    },
    setSelectedBulkAction(state, value) {
      state.selectedBulkAction = value;
    },
    setIsLoadingSelectedBulkAction(state, value) {
      state.isLoadingSelectedBulkAction = value;
    },
  },
  actions: {
    async getContactsBulkActions({ commit }, querySettings) {
      const { page, sortBy, descending } = querySettings.pagination;
      const shouldResetTable = page === 1;
      if (shouldResetTable) {
        commit('clearBulkActions');
      }

      const defaultOrder = "$sort[created_at]=-1"
      let params = sortBy ? `$sort[${sortBy}]=${(descending ? '-1' : '1')}` : defaultOrder;

      const limit = 10;
      const skip = limit * (page - 1);
      params += `&$skip=${skip}&$limit=${limit}`;

      const { archived } = querySettings;
      if (archived) {
        params += `&archived=${String(archived)}`;
      }

      try {
        commit('setBulkActionsInProgress', true);
        const { data } = await axios.get(`${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/bulk/report?${params}`);
        if (data.data.error) {
          commit('setBulkActionsError', 'Error getting bulk actions');
          return;
        }
        if (shouldResetTable) {
          commit('setBulkActionsSuccess', data);
        } else {
          commit('appendBulkActions', data);
        }
      } catch (error) {
        commit('setBulkActionsError', error);
      } finally {
        commit('setBulkActionsInProgress', false);
      }
    },
    async getBulkActionsContacts({ commit }, querySettings) {
      const { status, page  , limit, bulkActionId } = querySettings;

      const skip = limit * (page - 1);
      const params = `$skip=${skip}&$limit=${limit}&status=${status}`;
      const url = `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/bulk/report/${bulkActionId}`

      try {
        commit('setIsLoadingSelectedBulkAction', true);
        const { data: { total, data } } = await axios.get(`${url}?${params}`);
        commit('setContactsTotal', total);
        commit('setContacts', data.contacts);
        commit('setSelectedBulkAction', { ...data.action_log, status: data.status });
      } catch(error) {
        commit('setBulkActionsError', error);
      } finally {
        commit('setIsLoadingSelectedBulkAction', false);
      }
    },
  }
};
